import { useFetch } from "utils/hooks";

export function useCourses() {
  const { data, isLoading } = useFetch(`/v1/academy/courses/cursos-home`);
  
  return {
    courses: data?.data,
    isLoading: isLoading,
  };
}